import { fetchWithHeaders } from '@sendible/common';
import { completeUpload, uploadParts } from './utils';
import endpoints from '../../data-layer/endpoints';
import { getUrlWithCredentialsFromUser } from '../../utils/index';

export const useUploadThumbnail = ({ user, onError }: UseUploadThumbnailParams) => {
  const { method: uploadIntentMethod, endpoint: uploadIntentEndpoint } = endpoints.UploadMedias;

  return async ({ file, onUploadStarted }: UploadThumbnailArgs) => {
    const fileId = onUploadStarted(file);

    try {
      const body = {
        source: {
          type: 'File',
          filename: file.name,
          size: file.size,
          contentType: file.type,
        },
        initiator: 'ComposeBox',
      };

      const uploadIntentResponse = (await fetchWithHeaders({
        method: uploadIntentMethod,
        url: getUrlWithCredentialsFromUser(uploadIntentEndpoint, user),
        body,
        params: { dashboardId: user.userId },
      })) as { result: MediaUploadIntentType };
      const { result: uploadIntent } = uploadIntentResponse;

      const { uploadPromise } = uploadParts(uploadIntent, file);

      const uploadedParts = await uploadPromise;

      await completeUpload(uploadIntent, uploadedParts, user);

      return uploadIntent.id;
    } catch (error) {
      onError(error, { file, fileId });

      return null;
    }
  };
};
